function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const SnowflakeIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 17.5l-2.6.5 2.9 1.7c.5.3.6.9.4 1.4s-.9.6-1.4.4l-2.9-1.7.9 2.5c.4 1.2-1.5 1.9-1.9.7l-1.6-4.7-4.3-2.6v4.9l3.2 3.7c.9 1-.6 2.3-1.5 1.3l-1.7-2V27c0 .5-.5 1-1 1s-1-.5-1-1v-3.3l-1.8 2c-.9 1-2.4-.3-1.5-1.3l3.2-3.7v-4.9l-4.2 2.4-1.6 4.7c-.4 1.2-2.3.6-1.9-.7l.9-2.5-2.9 1.7c-.5.3-1.1.1-1.4-.4s-.1-1.1.4-1.4L5.1 18l-2.6-.5c-1.3-.3-.9-2.2.4-2l4.8 1L12 14l-4.2-2.5-4.8 1h-.2c-1.2 0-1.4-1.8-.2-2l2.5-.5-2.9-1.6c-.4-.3-.6-.9-.3-1.4.3-.5.9-.6 1.4-.4l2.9 1.7-.9-2.5c-.5-1.3 1.5-1.9 1.9-.7l1.6 4.7 4.2 2.4V7.4L9.8 3.7c-.9-1 .6-2.3 1.5-1.3l1.8 2V1c0-.5.5-1 1-1s1 .5 1 1v3.3l1.7-2c.9-1 2.4.3 1.5 1.3L15 7.4v4.9l4.2-2.4 1.6-4.7c.4-1.2 2.3-.6 1.9.7l-.9 2.5 2.9-1.7c.5-.3 1.1-.1 1.4.4s.1 1.1-.4 1.4L22.9 10l2.6.5c1.2.2 1 2-.2 2h-.2l-4.8-1L16 14l4.2 2.5 4.8-1c1.4-.3 1.8 1.7.5 2z"
  }));
};
export default SnowflakeIcon;